import { sendAnalyticsEvent, sendAnalyticsUserId } from '@/config/firebase'

import { ConsoleAdapter } from './adapters/console-adapter.js'
import { Analytics } from './analytics-layer.js'

declare const __APP_VERSION__: string
declare const __DEPLOY__: string
declare const __DEV__: boolean

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnalyticsInstance = any

const firebaseAdapter = {
  track(eventName: string, params?: Record<string, unknown>): void {
    sendAnalyticsEvent(eventName, params)
  },
  setUser(user: { id: string }): void {
    sendAnalyticsUserId(user.id)
  },
}

const adapters = __DEV__
  ? [new ConsoleAdapter(), firebaseAdapter]
  : [firebaseAdapter]

export const analytics: AnalyticsInstance = new Analytics({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  adapters: adapters as any[],
  environment: __DEPLOY__,
  appVersion: __APP_VERSION__,
})

export function setAnalyticsUser(userId: string): void {
  analytics.setUser(userId)
}

export function trackScreenView(
  screenName: string,
  params?: Record<string, unknown>
): void {
  analytics.screenView(screenName, params)
}

export function trackCtaClick(
  ctaName: string,
  params?: Record<string, unknown>
): void {
  analytics.ctaClick(ctaName, params)
}

export function trackApiError(
  endpoint: string,
  status: number,
  reason?: string,
  message?: string
): void {
  analytics.apiError({ endpoint, status, message, extra: { reason } })
}

export function trackUiError(
  message: string,
  params?: Record<string, unknown>
): void {
  analytics.uiError(message, params)
}

export function trackJsException(
  error: Error | string,
  params?: Record<string, unknown>
): void {
  analytics.jsException(error, params)
}
